import React from "react";
import styles from "../../../styles.module.scss";
import { SchedulePipelinesForm } from "@pages/workflow-page/SchedulePipelinesForm";
import { _canvasdagFormInitialValues } from "@pages/workflow-page/utils";
import { WorkflowCanvasTabInfo } from "@store/canvas";
import { InPageSpinner } from "@components/spinners/in-page-spinner";

interface HierarchyFormProps {
    activeStep: number;
    isLoadingElements: boolean;
    isEditForm: boolean;
    setActiveStep: (step: number) => void;
    handleOnSubmit: (values: any) => void;
    intialValuesScheduleFormState: any;
    isDisableRequrring: boolean;
    selectedScheduleTimingInfo: string;
    isDisableRunOnce: boolean;
}

const HierarchyScheduleForm: React.FC<HierarchyFormProps> = ({
    activeStep,
    setActiveStep,
    isEditForm,
    isLoadingElements,
    intialValuesScheduleFormState,
    handleOnSubmit,
    isDisableRequrring,
    selectedScheduleTimingInfo,
    isDisableRunOnce
}) => {
    const handleScheduleRhsFormSubmit = (values: WorkflowCanvasTabInfo['scheduleInfoForDag']) => {
        handleOnSubmit(values);
    }

    const handleScheduleDagWorkflow = (values?: WorkflowCanvasTabInfo['scheduleInfoForDag']) => {
        const tmp = "";
    }

    return (
        <>
            <div className={styles.jsonHierarchyScheduleForm}>
                <SchedulePipelinesForm
                    dagFormInitialValues={intialValuesScheduleFormState}
                    handleScheduleDagWorkflow={handleScheduleDagWorkflow}
                    handleScheduleRhsFormSubmit={
                        handleScheduleRhsFormSubmit
                    }
                    isJobScheduled={false}
                    isHierarchy={true}
                    isDagEnv={true}
                    selectedScheduleTimingInfo={selectedScheduleTimingInfo}
                    isDisableRequrring={isDisableRequrring}
                    isDisableRunOnce={isDisableRunOnce}
                    btns={
                        <div className={styles.hierarchyFormFooter}>
                            <button type="button" disabled={isLoadingElements} className="btn btn-grey btn-md" onClick={() => { setActiveStep(activeStep - 1); }}>
                                Back
                            </button>
                            <button className="btn btn-yellow btn-md" >
                                {isLoadingElements ?
                                    <InPageSpinner size="XSmall" color="black" />
                                    :
                                    <span>{!isEditForm ? "Publish" : "Update"}</span>
                                }
                            </button>
                        </div>
                    }
                />
            </div>
        </>
    );
};

export default HierarchyScheduleForm;
